import React from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmModal from '../../components/modals/ConfirmModal';

interface IConfirmModalProps {
  packName?: string;
  trigger: JSX.Element;
  onAccept?: () => void;
  onDecline?: () => void;
}

export default function JoinPackConfirmationModal({
  packName,
  trigger,
  onAccept = () => {},
  onDecline = () => {},
}: IConfirmModalProps) {
  const { t } = useTranslation();
  return (
    <ConfirmModal
      trigger={trigger}
      body={
        <>
          <br />
          <h3>{t('join_pack_name', { packName: packName || t('the_pack') })}</h3>
        </>
      }
      acceptText={t('confirm')}
      declineText={t('go_back')}
      onAccept={() => {
        onAccept();
      }}
      onDecline={() => {
        onDecline();
      }}
    />
  );
}
